import { FC, ReactNode, useMemo } from "react";
import dynamic from "next/dynamic";
import { Header } from "src/organisms/Header";
import styles from "./Page.module.scss";
import { showsRRPFootnote } from "src/molecules/RRPFootnote";
import { useRouter } from "next/router";

const Footer = dynamic(
  () => import("src/molecules/Footer").then((m) => m.Footer),
  { ssr: true }
);

const SubscribeOverlay = dynamic(
  () =>
    import("src/molecules/SubscribeOverlay").then((m) => m.SubscribeOverlay),
  { ssr: false }
);

interface Props {
  children: ReactNode;
  footer?: ReactNode;
}

const Page: FC<Props> = ({ children, footer }) => {
  const router = useRouter();

  const isCheckoutPage = useMemo(
    () => router.pathname.startsWith("/checkout"),
    [router.pathname]
  );

  const showRRPFootnote = useMemo(
    () => showsRRPFootnote(router.route),
    [router.route]
  );

  return (
    <>
      <main className={styles.page}>
        <Header isLoginFlow={false} isCheckoutPage={isCheckoutPage} />
        <div className={styles.container}>{children}</div>
        {footer ?? (
          <Footer className="Page__footer" showRRPFootnote={showRRPFootnote} />
        )}
        <SubscribeOverlay />
      </main>

      <div id="portal" />
      <div id="overlay-portal" />
    </>
  );
};

export { Page };
